import { requestParalegal } from '../libs/axios'

export const noticeScrollTemplate = (params) => requestParalegal.post('/noticeScrollTemplate/list/' + params) // 获取相应类型的滚动数据
export const centerDetailList = (params) => {
  console.log(params);
  return requestParalegal.post('/marketingCenter/centerDetailList', params)
} // 获取任务详情
export const login = (params,headers={}) => requestParalegal.post('/user/login', params,headers) // 发送验证码
